import { render, staticRenderFns } from "./ImgUpload.vue?vue&type=template&id=fd7c64f8&scoped=true&"
import script from "./ImgUpload.vue?vue&type=script&lang=js&"
export * from "./ImgUpload.vue?vue&type=script&lang=js&"
import style0 from "./ImgUpload.vue?vue&type=style&index=0&id=fd7c64f8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd7c64f8",
  null
  
)

export default component.exports